$(document).ready(function(){
 fetch('/cart.js')
      .then(response => response.text())
      .then((responseText) => {
        data = JSON.parse(responseText);
        var counterEl = document.querySelectorAll('.js-cart-count');

        counterEl.forEach((element) => {
          element.innerHTML = data.item_count
        })
      });

         setTimeout(function () {
          $('#agree_checkout').prop('checked', false)
         }, 500);


});